export default {
    /* LOAD_LABELS
    ---------------------------------------------------------------
    */
    LOAD_LABELS_REQUEST: state => {
        state.labelsLoading = true
    },
    LOAD_LABELS_SUCCESS: (state, data) => {
        state.labels = data.results
        state.labelsLoading = false
    },
    LOAD_LABELS_FAILURE: state => {
        state.labelsLoading = false
    },

    /* DELETE_LABEL
    ---------------------------------------------------------------
    */
    DELETE_LABEL_SUCCESS: (state, labelId) => {
        state.labels = state.labels.filter(label => label.id != labelId)
    },

    /* LOAD_PRODUCTS
    ---------------------------------------------------------------
    */
    LOAD_PRODUCTS_SUCCESS: (state, data) => {
        state.products = data
    },

    SET_LABELS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_LABELS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}
